import { State } from '@/store/modules/global/user/user.store';
import { MutationTree } from 'vuex';

const mutations: MutationTree<State> = {
  setUser(state: State, data: any): void {
    state.user.firstName = data.firstName;
    state.user.lastName = data.lastName;
  },
  setToken(state: State, data: any) {
    state.token = data.accessToken;
  },
  setTokenExp(state: State, exp: any) {
    state.tokenExp = exp;
  },
  setDashboard(state: State, data: any) {
    state.dashboard = data;
  },
  setEmail(state: State, data: any) {
    state.email = data;
  },
  setTeamId(state: State, data) {
    state.teamID = data;
  },
  setTeamName(state: State, data) {
    state.teamName = data;
  },
  setPrevTeamData(state: State, data) {
    state.prevTeamData = data;
  },
  setUserType(state: State, data) {
    state.userType = data;
  },
  setOapAccessToken(state: State, data) {
    state.oapAccessToken = data.token;
  },
  setIsAuthenticated(state: State, data) {
    state.isAuthenticated = data;
  },
  setUserLoginCount(state: State, data) {
    state.loginCount = data;
  },
  setUserLastLogin(state: State, data) {
    state.lastLogin = data;
  },
  setUserRoleId(state: State, data) {
    state.roleId = data;
  },
  setUserRoleName(state: State, data) {
    state.roleName = data;
  },
  setUserAccess(state: State, data) {
    state.isRoleValid = data;
  },
  // resets to default values on logout
  setDefaultValues(state: State, data) {
    state.username = '';
    state.token = '';
    state.email = '';
    state.user = {
      firstName: '',
      lastName: '',
    };
    state.tokenExp = '';
    state.teamID = '';
    state.accessToken = '';
    state.oapAccessToken = '';
    state.isAuthenticated = false;
    state.dashboard = '';
    state.lastLogin = '';
    state.loginCount = 0;
    state.roleId = '';
    state.roleName = '';
    state.isRoleValid = true;
    state.teamName = '';
    state.isBillingAdmin = false;
  },
  setIsBillingAdmin(state: State, data: Boolean) {
    state.isBillingAdmin = data;
  },
};
export default mutations;
